import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/list', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getInspectByID (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/update', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  confirmInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/confirm', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  cancelInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/inspect/cancel', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  reportStkList (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/list/stock/begin', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  reportStk (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/report/short/stock', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  reportItemBegin (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/list/item/begin', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  revokeInspect (URL, header, body, success, error) {
    Vue.axios.post(URL + 'mis/v1/revoke/confirm/begin', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_shotstorage.js